import {
  takeLatest,
  put,
  select,
  all,
  call,
} from 'redux-saga/effects';
import moment from 'moment-timezone';
import { dashboardsSelector } from '@store/tempDashboard/selectors';
import * as baseActions from '@store/errorDiagnostics/base/actions';
import * as birdChartActions from '@store/errorDiagnostics/birdChart/actions';
import * as dimensionTablesActions from '@store/errorDiagnostics/dimensionTables/actions';
import * as types from './types';
import * as baseTypes from '../base/types';
import * as birdChartTypes from '../birdChart/types';
import * as errorTableTypes from '../errorTable/types';
import * as dimensionTablesTypes from '../dimensionTables/types';
import * as barChartTypes from '../barChart/types';

function sleep(time) {
  return new Promise((resolve) => {
    setTimeout(() => resolve(), time);
  });
}

function* init() {
  yield all([
    put({ type: baseTypes.INIT }),
    put({ type: birdChartTypes.INIT }),
    put({ type: errorTableTypes.INIT }),
    put({ type: dimensionTablesTypes.INIT }),
    put({ type: barChartTypes.INIT }),
  ]);
}

function* initTempDashboard({ tempDashboardId }) {
  const dashboards = yield select(dashboardsSelector);
  const tempDashboard = dashboards[tempDashboardId];

  if (!tempDashboard || !tempDashboard.dashboard) {
    return;
  }
  yield put({ type: types.START_FETCHING });
  yield call(init);
  const { dashboard } = tempDashboard;
  try {
    const {
      base,
      dimensionTables,
      birdChart,
    } = dashboard;
    const { interval } = base;
    yield all([
      put(baseActions.setBaseState({
        ...base,
        interval: {
          ...interval,
          from: moment(interval.from),
          to: moment(interval.to),
        },
      })),
      put(birdChartActions.setBirdChartState(birdChart || {})),
      put(dimensionTablesActions.setDimensionTablesState(dimensionTables || {})),
    ]);
    yield sleep(300);
    yield put({ type: types.END_FETCHING });
  } catch (error) {
    console.error(error);
    throw error;
  }
}

function* watchInitTempDashboard() {
  yield takeLatest([
    types.INIT_TEMP_DASHBOARD,
  ], initTempDashboard);
}

export default [
  watchInitTempDashboard,
];
